import React from 'react'
import { Button, Text, Box, Heading, Divider, Link } from '@chakra-ui/react'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { AuthLayout } from '../../components'
import { ROUTES } from '../../contants'

const Signup = () => {
  const history = useHistory()
  return (
    <AuthLayout>
      <Box pos="absolute" top={0} right={0}>
        <svg
          width="236"
          height="307"
          viewBox="0 0 236 307"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M56 0H236V218C236 226.284 229.284 233 221 233H71C62.7157 233 56 226.284 56 218V0Z"
            fill="#F7F7F7"
          />
          <rect
            x="5"
            y="50"
            width="135"
            height="178"
            rx="10"
            fill="#F7F7F7"
            stroke="white"
            strokeWidth="10"
          />
          <rect
            x="86"
            y="164"
            width="105"
            height="138"
            rx="10"
            fill="#F7F7F7"
            stroke="white"
            strokeWidth="10"
          />
        </svg>
      </Box>

      <Box>
        <Heading
          fontFamily="'Poppins', sans-serif"
          lineHeight="1.5"
          fontSize="2.4rem"
          color="black">
          Quality Insurance from the Convenience of Your Devices.{' '}
        </Heading>
        <Text mt="1.6rem">Get Started.</Text>

        <Button
          onClick={() => history.push(ROUTES.insurance)}
          my="2.4rem"
          isFullWidth
          variant="blue">
          Buy Insurance
        </Button>
        <Divider mt="1.3rem" mb="2rem" />
        <Text textAlign="center">
          Have an account?{' '}
          <Link
            fontWeight="500"
            color="brand.blue"
            as={RouterLink}
            to={ROUTES.login}
            _hover={{ border: 'none', outline: 'none' }}
            _active={{ border: 'none', outline: 'none' }}
            _focus={{ border: 'none', outline: 'none' }}>
            Login here
          </Link>
        </Text>
      </Box>
    </AuthLayout>
  )
}

export { Signup }
